import * as list from './list';
import * as categories from './categories';
import * as info from './info';

export default {
  ...list,
  ...categories,
  ...info,
};
